import {useEffect, useRef, useState} from 'react';

import {useHistory} from 'react-router-dom';

interface UseNavigationBlockerOptions {
    when: boolean;
    onConfirm?: () => void;
}

export const useNavigationBlocker = ({when, onConfirm}: UseNavigationBlockerOptions) => {
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [nextLocation, setNextLocation] = useState<string | null>(null);
    const unblockRef = useRef<(() => void) | null>(null);

    useEffect(() => {
        if (!when) {
            if (unblockRef.current) {
                unblockRef.current();
                unblockRef.current = null;
            }
            return;
        }

        unblockRef.current = history.block((location) => {
            setNextLocation(location.pathname);
            setShowModal(true);
            return false;
        });

        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            return '';
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            if (unblockRef.current) {
                unblockRef.current();
                unblockRef.current = null;
            }
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [when, history]);

    const handleConfirm = () => {
        setShowModal(false);
        const locationToNavigate = nextLocation;
        setNextLocation(null);

        if (unblockRef.current) {
            unblockRef.current();
            unblockRef.current = null;
        }
        if (locationToNavigate) {
            if (onConfirm) {
                onConfirm();
            }

            setTimeout(() => {
                history.push(locationToNavigate);
            }, 0);
        }
    };

    const handleCancel = () => {
        setShowModal(false);
        setNextLocation(null);
    };

    return {
        showModal,
        handleConfirm,
        handleCancel,
    };
};
